export default __webpack_public_path__ + "static/media/magento-platform-poster.ce42a076.png";